/*
<summary>
   This file defines the initial (empty) state for the real Crimp Tool Inspection list
   (ToolManagement/GetCrimpToolInspectionList).
   Developer: Aashish Singh, Created Date: 27-Aug-2026
</summary>
*/

import { IToolCrimpInspectionListVM } from '../../models/response/IToolCrimpInspectionResponse';

export const getToolCrimpInspectionListInitialState: IToolCrimpInspectionListVM = {
  CrimpInspection: [],
  PagingDetails: {
    CurrentPage: 1,
    PageSize: 8,
    TotalPages: 0,
    TotalRecords: 0,
  },
};

export default getToolCrimpInspectionListInitialState;
